/**
 * Vistor Category Enum for Google Analytics
 * DOC: https://sph.atlassian.net/wiki/spaces/DTM/pages/8641120/GA+GTM+Documents
 */
export enum VisitorCatEnum {
  ANONYMOUS = 1,
  REGISTERED = 3,
  REGISTERED_VERIFIED = 12,
  REGISTERED_UNVERIFIED = 13,
  SUBSCRIBER = 2,
  GUEST = 4,
  IAP_SUBSCRIBER = 16,
}
